class GorgiasChatElement extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.initChat();
    });

    this.registerEvents();
  }

  /* eslint-disable */
  initChat() {
    GorgiasChat.init().then(function () {
      setTimeout(() => {
        const chatButtonIframe = document.querySelector('#chat-button');
        const myButton = document.querySelector('[data-chat-button]');
        GorgiasChat.close();
        chatButtonIframe.style = 'display:none;';
        myButton.style = 'opacity:100;cursor:pointer;';

        myButton.onclick = function () {
          if (GorgiasChat.isOpen()) {
            GorgiasChat.close();
            chatButtonIframe.style = 'display:none;';
          } else {
            GorgiasChat.open();
            chatButtonIframe.style = 'display:block;';
          }
        };
      }, 1000);
    });
  }
  /* eslint-enable */

  registerEvents() {
    document.addEventListener('section:product-info:reload', () => {
      this.initChat();
    });

    document.addEventListener('cart:rerendered', () => {
      this.initChat();
    });
  }
}
customElements.define('gorgias-chat', GorgiasChatElement);
